module.exports = __webpack_public_path__ + "img/fm_dark.64cf50a8.svg";